import React from 'react';
import { usePartyColors } from '../contexts/PartyColorContext';
import { Link } from 'react-router-dom';

const SpeechItem = ({ speech }) => {
  const { getPartyColor } = usePartyColors();
  return (
    <div className="p-6 border-b border-gray-200 dark:border-gray-700 transition">
      <div className="flex items-start">
        <div className="flex-1">
          <div className="flex items-center flex-wrap">
            <h3 className="font-medium text-lg mr-2">
              <Link to={`/profile/${encodeURIComponent(speech.speaker_first_name + ' ' + speech.speaker_last_name)}`} className="text-primary hover:underline">
                {speech.speaker_first_name} {speech.speaker_last_name}
              </Link>
            </h3>
            {speech.speaker_party && (
              <span
                className="inline-flex items-center justify-center py-1 px-3 text-xs font-medium rounded-full uppercase tracking-wider text-white mr-2 mb-1"
                style={{ backgroundColor: getPartyColor(speech.speaker_party) }}
              >
                {speech.speaker_party}
              </span>
            )}
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
            {new Date(speech.time).toLocaleTimeString()}
          </p>
          <div className="leading-relaxed text-gray-700 dark:text-gray-300 p-6 bg-gray-50 dark:bg-gray-800 rounded-lg mt-4 text-base">
            <div className="whitespace-pre-wrap break-words">
              {speech.content}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeechItem;
